import React from "react";
const Chat = React.lazy(() => import('./index'));

export const chatConfig = [
    {
        path: '/apps/Chat',
        element:<Chat/>
    }
];